<template>
  <div class="dynamic-qrcode"
       v-loading="loading"
       element-loading-text="数据加载中，请稍等...">
    <el-form size="mini" label-width="60px">
      <el-form-item label="链接地址">
        <el-input type="text" :value="signUrl" readonly="readonly">
          <el-button slot="append" type="default" icon="el-icon-document-copy" @click="copyContent(signUrl)"></el-button>
        </el-input>
      </el-form-item>
      <el-form-item label="访问密钥">
        <el-input type="text" :value="signInfo.visitKey" readonly="readonly">
          <el-button slot="append" type="default" icon="el-icon-document-copy" @click="copyContent(signInfo.visitKey)"></el-button>
        </el-input>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
export default {
  name: 'DynamicQrcode',
  props: {
    rowData: {
      type: Object,
      required: true
    },
    signInfo: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      loading: false
    }
  },
  computed: {
    signUrl () {
      if (this.signInfo && this.signInfo.id) {
        return `${window.location.origin}/static/app/manager/#/sign/index?signId=${this.signInfo.id}`
      }
      return ''
    }
  },
  methods: {
    copyContent (content) {
      if (!content) {
        this.$message.warning('复制内容为空')
        return
      }
      this.$copyText(content).then(() => {
        this.$notify({
          title: '复制成功',
          message: '内容成功复制到剪贴板',
          type: 'success'
        })
      }, () => {
        this.$message.error('浏览器不支持复制')
      })
    }
  },
  mounted () {
  }
}
</script>

<style lang="scss">
  .dynamic-qrcode {
    padding-top: 6px;
    padding-bottom: 6px;
    .el-form {
      .el-form-item {
        margin-bottom: 12px;
        &:last-child {
          margin-bottom: 0;
        }
        .el-form-item__label {
          color: #666;
          font-size: 12px;
        }
        .el-form-item__content {
          color: #303133;
          font-size: 12px;
          .el-input {
            width: 100%;
            & > .el-input__inner {
              background-color: #fafafa;
            }
            & > .el-input-group__append {
              background-color: #fff;
            }
          }
        }
      }
    }
  }
</style>
